import React, { useState, useEffect } from "react";
import {
    Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Box, Button,
    IconButton, TextField, CircularProgress
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";
import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";
import { splitToSentences } from "../../../Utils/additionalInfo";

const NewDistractingForDefinitionInEngSection = observer(() => {
    const newInfo = additionalInfo.newInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const [inputText, setInputText] = useState("");

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, distractingForDefinitionInEng: !expanded.distractingForDefinitionInEng });
    };

    useEffect(() => {
        const entries = splitToSentences(inputText);
        additionalInfo.deleteAllNewInfo("distractingForDefinitionInEng");
        if (entries.length > 0) {
            additionalInfo.createWithData("distractingForDefinitionInEng", entries);
        }
    }, [inputText]);

    return (
        <Grid item xs={12}>
            <Accordion expanded={expanded.distractingForDefinitionInEng} onChange={() => handleToggle("distractingForDefinitionInEng")} sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({newInfo.distractingForDefinitionInEng?.length || 0}) יצירת מסיחים עבור הגדרות באנגלית</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>

                    {/* תיבת הדבקה */}
                    <TextField
                        label="הדבק כאן טקסט עם מסיחים"
                        multiline
                        fullWidth
                        minRows={3}
                        value={inputText}
                        onChange={(e) => setInputText(e.target.value)}
                        sx={{ mb: 2 }}
                        inputProps={{ dir: "auto" }}
                        placeholder={`1. misleading option\n2. wrong synonym\nalternative meaning`}
                    />

                    {/* כפתורים */}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.createWithAi("distractingForDefinitionInEng")}
                        sx={{ mb: 2 }}
                        disabled={loading.create.distractingForDefinitionInEng}
                    >
                        {loading.create.distractingForDefinitionInEng ? <CircularProgress size={24} /> : "צור"}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => additionalInfo.addAllExistsInfo("distractingForDefinitionInEng")}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={loading.addAllExistsInfo.distractingForDefinitionInEng || newInfo.distractingForDefinitionInEng?.length === 0}
                    >
                        {loading.addAllExistsInfo.distractingForDefinitionInEng ? <CircularProgress size={24} /> : "שמור הכל"}
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={async () => {
                            const _id = additionalInfo.existsInfo._id;
                            if (!_id) return;

                            await additionalInfo.clearExistsInfoField(_id, "distractingForDefinitionInEng");
                            await additionalInfo.addAllExistsInfo("distractingForDefinitionInEng");
                        }}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={loading.addAllExistsInfo.distractingForDefinitionInEng || newInfo.distractingForDefinitionInEng?.length === 0}
                    >
                        {loading.addAllExistsInfo.distractingForDefinitionInEng ? <CircularProgress size={24} /> : "דרוס ושמור"}
                    </Button>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => additionalInfo.deleteAllNewInfo("distractingForDefinitionInEng")}
                        sx={{ mb: 2, ml: 1 }}
                        disabled={newInfo.distractingForDefinitionInEng?.length === 0}
                    >
                        מחק הכל
                    </Button>

                    {/* תצוגת מסיחים */}
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            justifyContent: "flex-start",
                            alignItems: "flex-start"
                        }}
                    >
                        {newInfo.distractingForDefinitionInEng?.length > 0 ? (
                            newInfo.distractingForDefinitionInEng.map((distr, index) =>
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        bgcolor: "#f0f0f0",
                                        p: 1,
                                        borderRadius: 2,
                                        maxWidth: "210px",
                                        minWidth: "100px",
                                        flex: "1 0 auto"
                                    }}
                                >
                                    <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                        {/* כפתור ניקוד */}
                                        <NakdanButton
                                            text={distr}
                                            onNikudComplete={(nikudText) => {
                                                additionalInfo.editNewInfo("distractingForDefinitionInEng", index, nikudText);
                                            }}
                                        />
                                        {/* כפתור שמירה */}
                                        <IconButton
                                            onClick={() =>
                                                additionalInfo.addExistsInfo({
                                                    fields: { distrForDefinitionInEng: distr },
                                                    field: "distractingForDefinitionInEng",
                                                    index
                                                })
                                            }
                                            disabled={additionalInfo.loading.addExistsInfo.distractingForDefinitionInEng?.[index]}
                                        >
                                            {distr && (additionalInfo.loading.addExistsInfo.distractingForDefinitionInEng?.[index]
                                                ? <CircularProgress size={24} />
                                                : <SaveIcon color="primary" />)}
                                        </IconButton>
                                        {/* כפתור מחיקה */}
                                        <IconButton onClick={() => additionalInfo.deleteNewInfo("distractingForDefinitionInEng", index)}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                    </Box>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        minRows={1}
                                        value={distr}
                                        onChange={(e) => additionalInfo.editNewInfo("distractingForDefinitionInEng", index, e.target.value)}
                                        sx={{
                                            direction: /^[\u0590-\u05FF]/.test(distr) ? "ltr" : "rtl",
                                            flexGrow: 1
                                        }}
                                    />
                                </Box>
                            )
                        ) : (
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Typography variant="body2" color="textSecondary">לא נוצרו מסיחים עבור הגדרות באנגלית</Typography>
                            </Box>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default NewDistractingForDefinitionInEngSection;
